import login from './login/login_en'
import forgotPassword from './forgotPassword/forgotPassword_en'
import changePassword from './changePassword/changePassword_en'
import home from './home/home_en'
import termsAndConditions from './termsAndConditions/termsAndConditions_en'
import updatePassword from './updatePassword/updatePassword_en';
import settlements from './settlements/settlements_en'
import authorizationTypes from './authorization/types/types_en';
import outpatientCare from './authorization/outpatient-care/outpatient-care_en';
import doctorFields from './authorization/outpatient-care/doctor-fields/doctor-fields_en';
import identityValidation from './authorization/outpatient-care/identity-validation/identity-validation_en';
import beneficiaryResults from './authorization/outpatient-care/beneficiary-results/beneficiary-results_en';
import createSettlement from './settlements/create-settlement/create-settlement_en'
import filters from './filters/filters_en'
import settlementDetail from './settlements/settlement-detail_en'
import authorizationDetail from './authorization/detail/authorizationDetail_en'
import prescriptionDoctorFields from './authorization/prescription/doctor-fields/doctor-fields_en';
import billing from './authorization/prescription/billing/billing_en';
import rcm from './rcm/home/rcmHome_en';
import rcmAccountDetail from './rcm/account-detail/account-detail_en'
import rcmChargeDetail from './rcm/charge-detail/charge-detail_en'
import supportsAdministrator from './rcm/support-administrator/support-administrator_en'
import rcmAgreements from './rcm/agreements/agreements_en'
import commentsRcm from './rcm/comments/comments_en'
import preSettlements from './rcm/pre-settlements/pre-settlements_en'
import rcmProducts from './rcm/products-configuration/ProductsConfiguration_en'
import rcmUploadAgreementMatrix from './rcm/upload-agreement-matrix/UploadAgreementMatrix_en'
import tfa from './tfa/tfa_en'
import homeV2 from './authorizationv2/homeV2_en'
import sponsorTemplates from './authorizationv2/sponsor-templates/sponsorTemplates_en'
import aiValidationDetail from './rcm/ai-validation-detail/ai-validation-detail_en'

export default {
  globalErrorUnknown: 'We had a technical glitch! Please, try again or contact your technical support team.',
  loading: 'Loading',
  errorTitle: 'An error has occurred',
  defaultErrorDescription: 'Please contact the support team for more information.',
  badCredentials: '¡Bad credentials! Please, try again.',
  searchMatches: 'Search Matches',
  buttons: {
    close: 'Close',
    save: 'Save',
    delete: 'Delete',
    cancel: 'Cancel',
    accept: 'Accept',
    add: 'Add',
    search: 'Search',
    back: 'Back',
  },
  errors: {
    inputValidations: {
      invalidNIT: "The information entered in {fieldName} does not meet the parameters. Please verify and correct the data.",
      required: 'Required field',
      invalidFormat: 'Invalid format',
      maxLength: 'The field has exceed the {n} characters limit',
      minLength: '{n} characters minimum',
      dynamicFieldInvalidFormat: 'Invalid format'
    },
    authorizationRequest: {
      emptyAuthorization: "Authorization creation failed, please contact the support team for more information."
    },
    dispensingRequest: {
      emptyApprovedProducts: "No product was approved for this authorization, please contact the support team for more information."
    },
    voidAuthorizations: {
      success: 'Authorization successfully voided.'
    }
  },
  drawer: {
    logout: 'Logout'
  },
  footer: {
    privacyLabel: 'Privacy'
  },
  locales: {
    'es-DO': 'Spanish',
    es: 'Spanish',
    en: 'English',
    pt: 'Portuguese'
  },
  identityDocumentTypes: {
      passport: 'Passport',
      nationalIdentityCard: 'National identity card',
      socialSecurityNumber: 'Social security number',
      taxIdentificationNumber: 'Tax identification number',
      electoralRegistryNumber: 'Electoral registry number'
  },
  genders: {
    male: 'Male',
    female: 'Female'
  },
  posology: {
      day: '{value} day | {value} days',
      unit: 'unit | units',
      medicalDeviceDescription: 'Use {0} ({1}) {2} for {3} ({4}) {5}',
      half: 'half',
      andConnector: 'and a',
      pointConnector: 'point',
      quarter: 'one quarter | {value} quarter',
  },
  sponsors: {
    umbrella: "Umbrella Osigu ARS",
    humano: 'Humano Seguros',
    universal: 'ARS Universal',
    primera: 'ARS Primera',
    senasa: 'ARS Senasa',
    humanoCategories: {
      global: "Global",
      platinum: "Platinum",
      conventional: "Convensional"
    }
  },
  voidAuthorization: {
    back: "Back",
    confirm: "Yes, cancel",
    title: "Cancel authorization",
    titleOnlyClaim: "Cancel claim",
    hint: "Confirm to cancel this authorization. This action cannot be reverted.",
    hintOnlyClaim: "Confirm to cancel this claim. This action cannot be reverted."
  },
  actions: {
    upload: 'Upload',
    delete: 'Delete',
    replace: 'Replace',
    view: 'Visualize',
    download: 'Download',
    edit: 'Edit'
  },
  yes: 'Yes',
  no: 'No',
  supportFileUploadSuccess: 'Document successfully uploaded. In a few minutes it will be available in Filezilla.',
  supportFileUploadSuccessBR: 'Document successfully uploaded. In a few minutes the analysis will be available.',
  SupportFileDeleteSeccess: 'File deleted successfully',
  supportFileRestrictedAsAccountLevel: 'Required at account level',
  emptyResults: "No results found",
  cancelFormButton: "Cancel",
  chronicTreatmentLabel: 'Chronic treatment',
  errorLoadingFile: 'An error occurred while loading the file, please try again or contact your technical support team.',
  ProtectedFile:'The document associated in {supports} is protected, please enable its reading',
  informationSuccessfullyUpdated: 'Information successfully updated',
  invalidFileType: 'Invalid file type, valid types are: {types}',
  errorEmailNotRegistered: 'The email is not registered, please check and try again.',
  login,
  forgotPassword,
  changePassword,
  home,
  termsAndConditions,
  updatePassword,
  settlements,
  authorizationTypes,
  outpatientCare,
  doctorFields,
  identityValidation,
  beneficiaryResults,
  filters,
  settlementDetail,
  createSettlement,
  authorizationDetail,
  prescriptionDoctorFields,
  billing,
  rcm,
  rcmAccountDetail,
  rcmChargeDetail,
  supportsAdministrator,
  rcmAgreements,
  commentsRcm,
  preSettlements,
  rcmProducts,
  rcmUploadAgreementMatrix,
  tfa,
  homeV2,
  sponsorTemplates,
  aiValidationDetail
}
